import { getApi, updateApi, formatParams } from '@/lib/api.service.js'

const currentUrl = `${import.meta.env.VITE_BACKEND_URL}/api/v2/users`;

export async function getUser(id) {
  try {
    let url = `${currentUrl}/${id}`;
    const response = await getApi(url);

    if (response && response.status >= 200 && response.status < 300) {
      return response.json
    } else {
      throw new Error(response?.json?.error || 'Failed to fetch user');
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function updateUser(id, data){
  // Needed so the API knows it's coming from autowise
  // Mainly used so we don't send out autowise emails to random people
  data.agent = "autowise"
  data = formatParams(data);

  try {
    let url = `${currentUrl}/${id}`;
    const response = await updateApi(url, data);

    if (response.status >= 200 && response.status < 300) {
      return response.json
    } else {
      throw new Error(response.json.error);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function updateUserPassword(id, data){
  // Needed so the API knows it's coming from autowise
  // Mainly used so we don't send out autowise emails to random people
  data.agent = "autowise"
  data = formatParams(data);

  try {
    let url = `${currentUrl}/${id}/update_password`;
    const response = await updateApi(url, data);

    if (response.status >= 200 && response.status < 300) {
      return response.json
    } else {
      throw new Error(response.json.error);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}
